/**
 * Wire-контракт правки общего товара (`Platform.Contracts/Catalog/CatalogProductEditDtos.cs`) и его проверка на границе:
 * неожиданная форма — `invalid-response`, а не пустая карточка.
 */
import { flag, integer, optionalInteger, optionalText, record, text, textList } from '../../../shared/decode'
import type { CommonProductEditResult, CommonProductEdited } from '../model/types'

export function decodeEditedProduct(raw: unknown, name = 'product'): CommonProductEdited {
  const item = record(raw, name)
  return {
    id: text(item.id, `${name}.id`),
    name: text(item.name, `${name}.name`),
    displayNameOverride: optionalText(item.displayNameOverride, `${name}.displayNameOverride`),
    sku: optionalText(item.sku, `${name}.sku`),
    unitCode: optionalText(item.unitCode, `${name}.unitCode`),
    barcodes: textList(item.barcodes, `${name}.barcodes`),
    version: integer(item.version, `${name}.version`),
    archived: flag(item.archived, `${name}.archived`),
    updatedAt: text(item.updatedAt, `${name}.updatedAt`),
    vatRate: optionalText(item.vatRate, `${name}.vatRate`),
    unitName: optionalText(item.unitName, `${name}.unitName`),
    isWeighted: item.isWeighted === null || item.isWeighted === undefined ? null : flag(item.isWeighted, `${name}.isWeighted`),
    paymentSubject: optionalInteger(item.paymentSubject, `${name}.paymentSubject`),
    paymentMethod: optionalInteger(item.paymentMethod, `${name}.paymentMethod`),
  }
}

export function decodeEditResult(raw: unknown): CommonProductEditResult {
  const item = record(raw, 'edit-result')
  return {
    operationId: text(item.operationId, 'edit-result.operationId'),
    replayed: flag(item.replayed, 'edit-result.replayed'),
    product: decodeEditedProduct(item.product, 'edit-result.product'),
  }
}
